import script from "./CultureStories.vue?vue&type=script&setup=true&lang=ts"
export * from "./CultureStories.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__